export enum BusEventEnum {
  RELOAD_CURRENT_PATH = 'reload-current-path',
  UPDATE_LOCATION = 'update-location',

  // Layouts
  RIGHT_PANEL_TOGGLE = 'right-panel-toggle',
  RIGHT_PANEL_HIDE = 'right-panel-hide',
  LEFT_PANEL_TOGGLE = 'left-panel-toggle',
  LEFT_PANEL_HIDE = 'left-panel-hide',

  // Swipe
  SWIPE_LEFT = 'swipe-left',
  SWIPE_RIGHT = 'swipe-right',

  // Scroll event
  SCROLL_EVENT = 'scroll-event',

  // Redirections
  GO_TO_HOME = 'go-to-home',

  // Focus
  DO_FOCUS_ON_MAIN = 'do-focus-on-main',

  // Logger
  LOGGER_DISPLAY_ENTRY = 'LOGGER_DISPLAY_ENTRY',
}
